module.exports = __webpack_public_path__ + "img/logo_sundosoft-300x150.9f3a0546.png";